// extracted by mini-css-extract-plugin
module.exports = {"vendorDashboardPage":"VendorDashboardPage_vendorDashboardPage__hnOKs","dataBlock":"VendorDashboardPage_dataBlock__cdXHt","resourceBlock":"VendorDashboardPage_resourceBlock__1IgBV"};